/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Cee_HintInputs */

const cs_property_registry_cee_hint = /** @type {(inputs: Property_Registry_Cee_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrální evidence exekucí. Pokud kancelář nemá přístup, otevřete ceecr.cz ručně.`)
};

const en_property_registry_cee_hint = /** @type {(inputs: Property_Registry_Cee_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central enforcement register. If the office has no access, open ceecr.cz manually.`)
};

/**
* | output |
* | --- |
* | "Central enforcement register. If the office has no access, open ceecr.cz manually." |
*
* @param {Property_Registry_Cee_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_hint = /** @type {((inputs?: Property_Registry_Cee_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_hint(inputs)
	return cs_property_registry_cee_hint(inputs)
});